import React from 'react';
import Navigation from './navigation';
var Layout = function Layout(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ React.createElement("section", {
        className: "content",
        role: "main"
    }, /*#__PURE__*/ React.createElement(Navigation, null), children);
};
export default Layout;
